import uuidv4 from 'uuid/v4';

export const Alert = class {
    constructor(type, message, autoClose) {
        this.id = uuidv4();
        this.type = type || 'info';
        this.message = message;
        this.autoClose = autoClose || true;
        this.state = 'open';
    }

    open() {
        this.state = 'open';
    }

    close() {
        this.state = 'close';
    }
};
